export const buildSelectionAriaLabel = (description: string, isUnreachable: boolean, unavailableText: string): string =>
  isUnreachable ? `${description}, ${unavailableText}` : description;
